import { render, staticRenderFns } from "./gift-record.vue?vue&type=template&id=fd075d0a&scoped=true"
import script from "./gift-record.vue?vue&type=script&lang=js"
export * from "./gift-record.vue?vue&type=script&lang=js"
import style0 from "./gift-record.vue?vue&type=style&index=0&id=fd075d0a&prod&lang=css"
import style1 from "./gift-record.vue?vue&type=style&index=1&id=fd075d0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd075d0a",
  null
  
)

export default component.exports